import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import L from 'leaflet'
import type { GeoJSONFeatureCollection, GeoJSONPoint } from '../../types/topology.ts'

const DOWNSTREAM_PANE = 'downstream-pane'
function ensurePane(map: L.Map): void {
  if (!map.getPane(DOWNSTREAM_PANE)) {
    const pane = map.createPane(DOWNSTREAM_PANE)
    pane.style.zIndex = '635'
    pane.style.pointerEvents = 'none'
  }
}

interface Props {
  members: GeoJSONFeatureCollection<GeoJSONPoint> | null
}

/** Highlights the downstream members (meters/transformers) of the selected
 *  device/transformer as amber rings in a dedicated pane. React-state driven so
 *  it survives the version-keyed GeoJSON remounts (SelectionHalo precedent). */
export function DownstreamHighlightOverlay({ members }: Props) {
  const map = useMap()

  useEffect(() => {
    if (!members || members.features.length === 0) return
    ensurePane(map)
    const layerGroup = L.layerGroup().addTo(map)
    const bounds: L.LatLng[] = []
    for (const f of members.features) {
      const coords = f.geometry?.coordinates
      if (!coords) continue
      const [lng, lat] = coords
      const ll = L.latLng(lat, lng)
      bounds.push(ll)
      L.circleMarker(ll, {
        pane: DOWNSTREAM_PANE, radius: 7, color: '#f59e0b', weight: 2,
        fillColor: '#f59e0b', fillOpacity: 0.35, interactive: false,
      }).addTo(layerGroup)
    }
    if (bounds.length >= 1) {
      map.fitBounds(L.latLngBounds(bounds).pad(0.3), { maxZoom: 17, duration: 0.6 })
    }
    return () => {
      layerGroup.remove()
    }
  }, [members, map])

  return null
}
